import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
// import { allPermissions } from '@access/index'
// import { accessPermission } from '@/permissions/permissions'

// const {
//   STAFF: {
//     USER: {
//       VIEW
//     },
//   },
// } = allPermissions

const NotFound = () => import('./NotFound.vue')

export const NOT_FOUND_PAGE_NAME = 'cabinet:not-found'

// URLs

export const NOT_FOUND_PAGE_URL = ''

export function createRoutes(options): RouteRecordRaw[] {
  return [
    route(NOT_FOUND_PAGE_URL, NotFound, NOT_FOUND_PAGE_NAME, {
      meta: {
        breadcrumb: 'not-found',
        // ...accessPermission([VIEW], options),
      }
    }),
  ]
}
